import { useQuery } from "@tanstack/react-query";
import { useProject } from "../project";
import { apiClient } from "../service/tekkr-service";

export function useProjectTasksQuery() {
    const { project } = useProject();
    return useQuery({
        queryKey: ["project", project.id, "tasks"],
        queryFn: async () => {
            const res = await apiClient.getProjectTasks({
                params: {
                    id: project.id,
                },
            });
            if (res.status !== 200) {
                throw new Error("Failed to get project tasks");
            }
            return res.body;
        },
    });
}
